import React from "react";
import "./style.scss";

type PropType = {
  onClick: any;
  title: string;
};

export const ExploreItem: React.FC<PropType> = ({ onClick, title }) => {
  return (
    <div className="explore-card" onClick={onClick}>
      <p>{title}</p>
    </div>
  );
};
